import React, { PropsWithChildren } from "react";
import { animated, useSpring } from "react-spring";
import { fadeIn } from "../../styles/springs";

function ContainerFadeIn(props: PropsWithChildren<{}>) {
  const springPropsFadeIn = useSpring(fadeIn);
  return <animated.div style={springPropsFadeIn}>{props.children}</animated.div>;
}

export default ContainerFadeIn;
